import "core-js/modules/web.dom.iterable";
import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moduleConfig from "../moduleConfig";
import request from "@/utils/request";
function _getData(data, url) {
  return request({
    url: url,
    method: "get",
    data: data
  });
}
export default {
  name: 'OpSelect',
  props: {
    api: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: null,
      required: false,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      required: false,
      default: ""
    },
    size: {
      type: String,
      required: false,
      default: "mini"
    },
    optiondata: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    componentId: {
      type: Number,
      required: false,
      default: 0
    },
    placeholder: {
      type: String,
      required: false,
      default: "请选择"
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    remote: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      moduleConfig: moduleConfig,
      options: [],
      insValue: this.value
    };
  },
  watch: {
    value: function value() {
      console.log(888, this.value);
      if (Array.isArray(this.value)) {
        this.insValue = this.value.map(function (item) {
          return JSON.parse(item).value;
        });
      } else {
        this.insValue = this.value;
      }
    }
  },
  created: function created() {
    this.getData({});
  },
  mounted: function mounted() {},
  methods: {
    getData: function () {
      var _getData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.api) {
                _context.next = 7;
                break;
              }
              _context.next = 3;
              return _getData(data, this.api);
            case 3:
              result = _context.sent;
              this.options = result.data;
              _context.next = 8;
              break;
            case 7:
              this.options = this.optiondata;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getData(_x) {
        return _getData2.apply(this, arguments);
      }
      return getData;
    }(),
    change: function change(val) {
      var _this = this;
      console.log(this.insValue);
      var items = null;
      if (Array.isArray(this.insValue)) {
        items = [];
        this.insValue.forEach(function (key) {
          _this.options.forEach(function (item) {
            if (key === item.id) {
              items.push(JSON.stringify(item));
            }
          });
        });
        this.$emit("input", items);
        this.$emit("change", items);
      } else if (this.insValue !== "") {
        this.options.forEach(function (item) {
          if (_this.insValue === item.id) {
            items = item;
          }
        });
        this.$emit("input", items.id);
        this.$emit("change", items.id);
        this.$emit("label", items.personName);
      } else if (this.insValue === "") {
        this.$emit("input", "");
        this.$emit("change", "");
      }
    },
    clear: function clear() {
      this.$emit("clear", {});
    },
    remoteMethod: function () {
      var _remoteMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(query) {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(query !== '')) {
                _context2.next = 8;
                break;
              }
              this.loading = true;
              _context2.next = 4;
              return _getData({}, this.api + query);
            case 4:
              result = _context2.sent;
              if (result.code === 200) {
                this.loading = false;
                this.options = this.optiondata;
              } else {
                this.$message({
                  type: "error",
                  message: result.msg
                });
              }
              _context2.next = 9;
              break;
            case 8:
              this.options = [];
            case 9:
              this.$emit("remoteMethod", {});
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function remoteMethod(_x2) {
        return _remoteMethod.apply(this, arguments);
      }
      return remoteMethod;
    }()
  }
};